export default {
    main:'/',
    home: '/room/:roomID',
    room:'/r/:roomID',
    endCall:'/endcall/:roomID',
    roomFull:'/roomFull'
}